module.exports = __webpack_public_path__ + "c0bf519850a194247d117ba3e187c512.MP3";